import React, {useEffect,useState} from 'react';
import axios from 'axios';
const Utility= require('../Utility/Utilty');


export default function CartItem({ ID, productID, sizeSelection, quantity, onUpdateHandler, triggerFetch, checkOutItem }) {
    const [totalPrice,setTotalPrice]=useState(0);
    const [productPrice,setProductPrice]=useState(0);
    const [product, setProduct] = useState({
        ID: '',
        Description: '',
        Price: '',
        Discount: '',
        Image0: null,
        Image1: null,        
        Image2: null,
        ImageType0: null,
        ImageType1: null,
        ImageType2: null,
        Video: null,
        NewItem: false,
        StylingProduct: null,
        InStockQ: '',
        XS: '',
        S: '',
        M: '',
        L: '',
        XL: '',
        
      });

    useEffect(() => {
        // Fetch product when the component mounts
        //setProduct(null);
        //console.log("PID: ",productID, " s:",sizeSelection," q:",quantity);
        if(productID){
        fetch(`/listProductsWithSizes?filter=ID='${ productID }'`)
            .then(response => response.json())
            .then(data => setProduct(data[0]))  
            .catch(error => console.error('Error fetching product:', error));
        }
    }, [productID]);

    useEffect(() => {
        //console.log(product);
        setProductPrice(parseFloat(product.Price)-( parseFloat(product.Price) * ( parseFloat(product.Discount)/100 ) ));    
    }, [product]);

    useEffect(() => {        
        setTotalPrice((productPrice)*parseInt(quantity));    
    }, [productPrice]);



    const updateCartItem = async (e,x) => {
        var id=e.currentTarget.id;
        id= id.replace('incr_','');
        id= id.replace('decr_','');
        
        const quantity=document.getElementById(`quantity_${id}`)
        var quantityInt =parseInt(quantity.innerText);
        var update = false
        if(product.InStockQ > quantityInt || quantityInt > 0)
        {
            if(x==='+'){
                if(product.InStockQ > quantityInt){
                    quantityInt=quantityInt+1;  
                    update= true;
                }         
            }
            else if (x==='-'){
                if(product.InStockQ >= quantityInt && (quantityInt - 1) > 0){
                    quantityInt= quantityInt-1; 
                    update= true;
                }               
            }
            if(update){
                const tPrice=productPrice*quantityInt;
                try {
                    const formData = new FormData();
                    formData.append('ID', id);          
                    formData.append('Quantity', quantityInt);   
                    formData.append('TotalPrice', tPrice );   
                    const response = await axios.post(`/UpdateBagItemQuantity`, formData, {
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    });
                
                    console.log('Cart item updated successfully:', response.data);
                    quantity.innerText=quantityInt;                
                    setTotalPrice(tPrice);
                    triggerFetch();
                    onUpdateHandler();
                    
                } catch (error) {
                    console.error('Error updating cart item:', error);
                }
            }
        }

    }
        

    
    const util= new Utility();
    return (
       

        <div className="cart-item">
            {( typeof product === 'undefined' ) ? (
            <div className='w-100 text-center m-2'>Product not available.</div>
        ) : (
            <>
            <img className="imgfit" src={util.getImageUrl(product.ImageType0,product.Image0)} alt="Item Image" />
            <div className="item-info">
                <p>{product.Description}</p>
                <p>
                    Size:{' '}
                    <span className="custom-dropdown text-center">
                        <div id="sizes">{sizeSelection} </div>
                    </span>
                </p> 
                <div className="quantity-control">
                    Qty:<span>{' '}
                    {(checkOutItem===true ?(
                    <>
                        {'['}<span id={`quantity_${ID}`} className='text-center'>{quantity}</span>{']'}
                    </>
                    ) : (
                    <>
                        <button id={`incr_${ID}`} onClick={(e)  => updateCartItem(e,'-')}>-</button>
                        {'['}<span id={`quantity_${ID}`} className='text-center'>{quantity}</span>{']'}
                        <button id={`decr_${ID}`} onClick={(e)  => updateCartItem(e,'+')}>+</button>
                    </>
                    ) )}
                                    </span> </div>
                <p> &plusmn; ZAR {totalPrice}</p>
            </div>
        </>
           )}
    </div>
     


);

}